module.exports = __webpack_public_path__ + "img/fi-rr-life-ring.bd82b7fd.svg";